module.exports = __webpack_public_path__ + "img/03.5c4326f0.jpg";